<div class="organization-member-invite-form-container">
  <div class="organization-member-invite-form-container__description">
    {{ "LABELS.INVITE_MEMBERS_DESCRIPTION" | translate }}
  </div>
  <div class="organization-member-invite-form-container__form">
    <span>{{ "LABELS.INVITE_BY_EMAIL" | translate }}</span>
    <div class="d-flex justify-content-between align-items-center pb-3">
      <app-control-wrapper class="w-100" [control]="formGroup.get('email')" [errors]="errors.email" [isShowHelper]="false">
        <input
          class="form-control"
          type="text"
          control-wrapper
          name="email"
          id="email"
          [placeholder]="'LABELS.EMAIL_ADDRESS' | translate"
          [formControl]="formGroup.get('email')"
          [mask]="'F*'"
          [patterns]="CUSTOM_MASK"
          [dropSpecialCharacters]="false"
          [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
        />
      </app-control-wrapper>
    </div>

    <span>{{ "LABELS.ROLE" | translate }}</span>
    <div class="d-flex justify-content-between align-items-center">
      <app-control-wrapper class="w-100" [control]="formGroup.get('role')" [helper]="roleHelperText" [errors]="errors">
        <ng-select
          id="role"
          class="custom"
          [formControl]="formGroup.get('role')"
          [items]="roles"
          [bindLabel]="'label'"
          [bindValue]="'id'"
          [clearable]="false"
          control-wrapper
        ></ng-select>
      </app-control-wrapper>
    </div>

    <div *ngIf="!isAdmin" class="organization-member-invite-form-container__companies-select">
      <p class="organization-member-invite-form-container__companies-select-description">
        {{ "LABELS.INVITE_MEMBERS_IOR_SELECT_DESCRIPTION" | translate }}
      </p>
      <div
        class="custom-control custom-checkbox organization-member-invite-form-container__companies-select-checkbox pb-2"
        *ngFor="let company of companies; let i = index"
      >
        <input
          type="checkbox"
          [formControl]="getCompanyControlById(company.id)"
          class="custom-control-input"
          [id]="'company-' + company.id"
        />
        <label class="custom-control-label" [for]="'company-' + company.id">
          {{ company.businessName }}
        </label>
      </div>
    </div>
  </div>

  <div class="organization-member-invite-form-container__invite-button-container px-4 py-4 d-flex justify-content-center">
    <button
      [disabled]="formGroup.invalid || (!this.isAdmin && !isAnyCompanySelected)"
      class="organization-member-invite-form-container__invite-button btn btn-primary d-flex align-items-center justify-content-center"
      (click)="sendInvite()"
    >
      {{ "BUTTON.SEND" | translate }}
      <img class="ml-2" src="assets/icons/icon_arrow_right_white.svg" />
    </button>
  </div>
</div>
